/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */

Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.TimeRange = (function() {
  function TimeRange() {
    Monet.UI.Fields.TimeField.apply(this, arguments);

    this.value = { ini: "", fin: "" };
    this.createElement = function() {
      this.inputIni = document.createElement("input");
      this.inputFin = document.createElement("input");

      this.inputIni.type = "text";
      this.inputIni.className = "timeField";

      this.inputFin.type = "text";
      this.inputFin.className = "timeField";

      if (this.maxSize) {
        this.inputIni.maxLength = this.maxSize;
        this.inputFin.maxLength = this.maxSize;
      }

      this.rootEl.appendChild(this.inputIni);
      this.rootEl.appendChild(this.inputFin);
    };

    this.getValue = function() {
      return this.value;
    };

    this.isEmpty = function() {
      return !(this.getValue() && this.getValue().ini && this.getValue().fin);
    };

    this.setValue = function(values) {
      this.value = values || this.value;
      this.setInputValue();
    };

    this.setInputValue = function() {
      if (this.inputIni && this.inputFin) {
        this.inputIni.value = this.value.ini;
        this.inputFin.value = this.value.fin;
      }
    };

    this.initializeSpecialBehavior = function() {
      const date = new Monet.Date.GeneralFunctions();
      date.setTimePicker(this.inputFin);

      options.beforeShow = options.onSelect = (input, dpInst) => {
        $("main").append($("#ui-datepicker-div"));
        this.focusNext(
          'button.ui-datepicker-close[data-handler="hide"]',
          dpInst
        );
      };

      date.setTimePicker(this.inputIni);
    };

    this.clear = function() {
      this.setValue({
        ini: "",
        fin: ""
      });
    };

    this.render = function() {
      this.createElement();
      this.setInputValue();
      this.initializeSpecialBehavior();
      return this.rootEl;
    };
  }

  return TimeRange;
})();
